/**
 * Scrolling Component
 * 
 * @description
 * <p>Sets up and manages Assisted Scrolling</p>
 * <p>On page load, sets up handlers for scroll, touchmove and click touch events, including handlers that auto-scroll to next/previous section based on scroll direction</p>
 * <p>Self-initializes when you include this module.</p>
 * 
 * @module scrolling
 * 
 * @namespace site.scrolling
 */
( /* @lends module:scrolling */ function(site, $){
	"use strict";
(function($){
	var trace = {push: function() {}},
		selectors = {                              // Existing DOM element selectors
			site : "#site",                        // site wrapper
			nav : "header",                           // main nav
			footer : "footer",                     // site footer
			scrlAssistWrap : ".scroll-indicator",  // scroll assist
			scrlAssist : ".scroll-indicator-svg",  // scroll assist
			section : ".scroll-to",                // auto scroll section
			scrlAnim : ".scrolling",               // animate on scroll
		},
		classes = {             // classes set or used by logic
			toTop : 'up',       // scroll assist jump to top
			active : 'active',  // active element
			past : 'post'       // active element scrolled past
		},
		$dom = {},  // cached DOM element references
		currentSection = 0,  // current site section in focus
		bottomSectionReached = false,
		vis = {            // visibility logic values
			nav : 300,     // minimum pixel scroll distance to turn on the nav active state
			secMinDown : 75,   // minimum percent position on screen to set active state for sections (top of element from top of screen)
			secMinUp: 75, // minimum percent position on screen to set active state for sections (bottom of element from bottom of screen)
			animMin : 60,  // minimum percent position on screen to set active state for animation elements (top of element from top of screen)
			animMax : 100,  // maximum percent position on screen to set past state for animation elements (bottom of element from bottom of screen)
			foot : 80      // minimum percent position on screen of footer element to set scroll assit to jump to top
		},
		initialLoad = true, // initial load
		isRoot = false, 	// bool to represent if site is on root path
		isMobile = false, 	// bool to represent if user is on mobile
		firstSegment,
		lastScrollPos = -1, // last window scroll position for determining scroll direction
		assisting = false,  // are we currently controlling the scroll
		assistTime = 1000, // time in milliseconds to animate assisted scroll
		listenDelay = 500,
		$indicatorSVG = $('<svg class="scroll-indicator-svg" preserveAspectRatio="xMaxYMax meet" viewbox="0 0 24 50" xmlns="http://www.w3.org/2000/svg">'
			+'<g transform="translate(17,0)"><polyline class="scroll-indicator-svg-chevron scroll-indicator-svg-chev1" stroke-linecap="round" stroke="#fff" stroke-width="2" fill="none" transform="rotate(90.000000)" points="6 -6 16 5 6 16"></polyline></g>'
			+'<g transform="translate(17,15)"><polyline class="scroll-indicator-svg-chevron scroll-indicator-svg-chev2" stroke-linecap="round" stroke="#fff" stroke-width="2" fill="none" transform="rotate(90.000000)" points="6 -6 16 5 6 16"></polyline></g>'
			+'<g transform="translate(17,30)"><polyline class="scroll-indicator-svg-chevron scroll-indicator-svg-chev3" stroke-linecap="round" stroke="#fff" stroke-width="2" fill="none" transform="rotate(90.000000)" points="6 -6 16 5 6 16"></polyline></g>'
			+'</svg>');

	/**
	 * Scrolling Initializer
	 */
	function init() {
		trace.push('[scrolling.js] init()');

		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		// cache DOM elements
		$dom.site = $(selectors.site);
		$dom.nav = $(selectors.nav);
		$dom.footer = $(selectors.footer);
		$dom.scrlAssistWrap = $(selectors.scrlAssistWrap);
		$dom.scrlAssistWrap.append($indicatorSVG.clone());
		$dom.scrlAssist = $(selectors.scrlAssist);
		$dom.section = $(selectors.section);
		$dom.scrlAnim = $(selectors.scrlAnim);

		isRoot = site.checkRoot();
		isMobile = site.checkMobile();
		firstSegment = site.getSegments(1);

		listeners();
		scrolling();  
	}

	/**
	 * All Global listeners registered here
	 */
	function listeners() {
		// Site/Global events
		$(window).on('scroll',function() {
			scrolling();
			site.history.scrolling();
			site.newsroom.scrolling();
		});
		$(document).on('touchmove',function(){
			scrolling();
		});

		
		// Scroll Assist
		$dom.scrlAssist.on('click touch', function(e) {
			
			// should assist scroll to top of page?
			//if(check_ie() && (!$(this).parents('footer').length)){
			if(check_ie()){
				if (!("classList" in document.createElement(classes.toTop))) {
				HTMLElement.prototype.classList = {
					contains: function () {
						scrollToSection(0,true);
					}
				};
				}// otherwise scroll to next
				else {
					// If not on home, scroll to first section only
					site.getSegments(1) === '' ? scrollToSection(currentSection+1,true) : scrollToSection(1,true);
					
				}
			}else{
				
				if($(e.target).hasClass(classes.toTop)	|| 
					($dom.scrlAssist[1] && $dom.scrlAssist[1].classList.contains(classes.toTop))
				) {
					scrollToSection(0,true);
				}// otherwise scroll to next
				else {
					// If not on home, scroll to first section only
					site.getSegments(1) === '' ? scrollToSection(currentSection+1,true) : scrollToSection(1,true);
					
				}
			}
			
		});
	}
	
	/**
	 * @public
	 * @function site.scrolling.checkVisible
	 * @description Check if DOM element is within viewscreen
	 * @param {DOMElement} $elm
	 * @return {object} returns object with keys for pixels from top of screen, pixels from bottom of screen and percentage from top of screen to top of element and bottom to bottom
	 * @example
	 * {@lang JavaScript}
	 * $(window).on('scroll',function() {
	 *    scrolling();
	 *    site.history.scrolling();
	 *    site.newsroom.scrolling();
	 * });
	 */
	function checkVisible($elm) {
		var winTop = Math.floor($(window).scrollTop()),
			winHeight = Math.floor($(window).outerHeight()),
			winBot = winTop+winHeight,
			elmTop = Math.floor($elm.offset().top),
			elmHeight = Math.floor($elm.outerHeight()),
			elmBot = elmTop+elmHeight,
			visible = {
				isVis : false,
				top : 0,
				topPerc : 0,
				bottom : 0,
				bottomPerc : 0,
				perc : 0,
				winT: winTop,
				winH: winHeight,
				elmT: elmTop,
				height: elmHeight
			};

		visible.top = elmTop - winTop;
		visible.bottom = winBot - elmBot;

		//trace.push("winTop = "+winTop);
		// trace.push("elmTop = "+elmTop);

		visible.perc = (( ( winTop - elmTop  ) / (elmHeight ) )*-100)-100;

		if(visible.perc < -200) {
			//visible.perc = -200;
		}

		if(visible.perc > -100) {
			//visible.perc = -100;
		}

		// top of element is within the viewport
		if(elmTop >= winTop && elmTop < winBot) {
			visible.topPerc = Math.floor((visible.top/winHeight)*100);
			visible.isVis = true;
		}
		// top of element is above the viewport
		else if(elmTop < winTop) {
			visible.topPerc = 0;
		}
		// top of element is below viewport
		else if(elmTop > winBot) {
			visible.topPerc = 100;
		}

		// bottom of element is in view
		if(elmBot > winTop && elmBot <= winBot) {
			visible.bottom = winBot - elmBot;
			visible.bottomPerc = Math.floor((visible.bottom/winHeight)*100);
			visible.isVis = true;
		}
		// bottom of element is above the viewport
		else if(elmBot < winTop) {
			visible.bottomPerc = 100;
		}
		// bottom of element is below viewport
		else if(elmBot > winBot) {
			visible.bottomPerc = 0;
		}

		if(elmTop < winTop && elmBot > winBot) {
			visible.isVis = true;
		}

		return visible;
	}
	function check_ie() {
		var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
		var msie = ua.indexOf('MSIE '); // IE 10 or older
		var trident = ua.indexOf('Trident/'); //IE 11
		var checkidval = 0;
		if(msie > 0){
			var checkidval = 1;
		}
		if(trident > 0){
			var checkidval = 1;
		}

		return checkidval;
	}

	/**
	 * Modifies DOM elements based on scroll position
	 */
	function scrolling() {
		var scrollTop = Math.floor($(window).scrollTop()),
			footerVis = checkVisible($dom.footer),
			current = currentSection,
			scrollDir = lastScrollPos <= scrollTop ? 'down' : 'up';

		// Toggle nav background
		if(scrollTop > vis.nav) {
			if(!$dom.nav.hasClass(classes.active)){
				//trace.push('adding active state to nav');
				$dom.nav.addClass(classes.active);
			}
		} else {
			if($dom.nav.hasClass(classes.active)){
				//trace.push('removing active state from nav');
				$dom.nav.removeClass(classes.active);
			}
		}

		// toggle scroll assist up/down 
		if(footerVis.isVis && footerVis.topPerc <= vis.foot) {
			if(!$dom.scrlAssist.hasClass(classes.toTop)) {
				$dom.scrlAssist.addClass(classes.toTop);
			}
		}
		else if($dom.scrlAssist.hasClass(classes.toTop)) {
			$dom.scrlAssist.removeClass(classes.toTop);
		}

		toggleHeader(scrollDir, scrollTop);

		// Set States for Scroll Anim Elements
		$dom.scrlAnim.each(function(i,elm) {
			setAnimState($(elm));
		});


		// make sure we don't already have controll of the scroll position
		if(!assisting) {
			// Set States for Sections
			$dom.section.each(function(i,elm) {
				var visible = checkVisible($(elm));
				
				if(!visible.isVis) {
					return;
				}
				
				// check for current section index
				if(scrollDir == 'down' && visible.topPerc <= vis.secMinDown) {
					current = i;
				}
				else if(scrollDir == 'up' && visible.bottomPerc >= vis.secMinUp) {
					current = i;
				}

			});

			if(currentSection === $dom.section.length - 1) {
				bottomSectionReached = true;
			}

			// if current section has changed, do things
			if(currentSection != current){
				currentSection = current;
				trace.push('current section index changed to: '+currentSection);



				if(isRoot && bottomSectionReached) return;
				
				// clients wants scroll assist only from, or to hero section
				if (isMobile) return;
				
				if(firstSegment === 'history' && site.history.scrollIdx <= 1) scrollToSection(current);

				if(firstSegment !== 'history') scrollToSection(current);
			}
		}

		lastScrollPos = scrollTop;
	}

	/**
	 * Checks visibility and offset position of an element reletive to viewscreen to set animation state
	 * @param {jQuery Object} $elm the element to set
	 */
	function setAnimState($elm) {
		var visible = checkVisible($elm);

		// if top of element is below the minimum add active state
		if(visible.topPerc <= vis.animMin) {
			if(!$elm.hasClass(classes.active)) {
				// trace.push('adding active state to ', $elm);
				$elm.addClass(classes.active);
			}
		} else if($elm.hasClass(classes.active)) {
			// trace.push('removing active state from ', $elm);
			$elm.removeClass(classes.active);
		}

		if(visible.bottomPerc >= vis.animMax) {
			if(!$elm.hasClass(classes.past)) {
				// trace.push('adding past state to ', $elm);
				$elm.addClass(classes.past);
			}
		} else if($elm.hasClass(classes.past)) {
			// trace.push('removing past state from ', $elm);
			$elm.removeClass(classes.past);
		}

	}

	/**
	 * Take over scroll to move user to section index
	 * @param  {integer} index the index of section to scroll to
	 */
	function scrollToSection(index,isBtn) {

		if (index === $dom.section.length) bottomSectionReached = true;
		if (!isBtn && isRoot && bottomSectionReached && index !== 0) return;

		// trace.push('scrollToSection: '+index);
		
		// if there are no defined sections scroll to top else if index is larger than section count, scroll to footer
		var $section = $dom.section.length === 0 ? $dom.site : index < $dom.section.length ? $($dom.section[index]) : $dom.footer,
			scrollPos = $section.offset().top;

		// set flag that we have control of scroll
		assisting = true;
	}

	/**
	 * toggles the header depending on scroll direction
	 *
	 * @param   {string}  scrollDirection  'down' or 'up' representing scroll direction
	 */
	function toggleHeader(scrollDirection, scrollTop) {

		if (initialLoad) {
			initialLoad = false;
			return;
		}

		if(scrollTop < 5) {
			$dom.nav.hasClass('goUp') ? $dom.nav.removeClass('goUp') : null;
			return;
		}

		if (scrollDirection === 'down') {
			$dom.nav.hasClass('goUp') ? null : $dom.nav.addClass('goUp');
		} else {
			$dom.nav.hasClass('goUp') ? $dom.nav.removeClass('goUp') : null;
		}
	}
	


	// Public API definitions
	site.scrolling = {
		checkVisible : checkVisible
	};

	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
